import { render } from "./resource-metric.vue?vue&type=template&id=352314b5"
import script from "./resource-metric.vue?vue&type=script&lang=js"
export * from "./resource-metric.vue?vue&type=script&lang=js"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__